import { Box, Text } from '@domain-group/suit-theme'

const Deadline = (props: { deadline?: string}) => {
  const { deadline } = props

  return (
    <Box>
      {!!deadline && (
        <Box flexDirection="row" fontSize="xsmall" marginTop="small">
          <Text color="faintGrey" flexDirection="row">
            Due:&nbsp;
          </Text>
          <Text color="bodyFontLightColor" style={{ whiteSpace: 'nowrap' }}>
            {deadline}
          </Text>
        </Box>
      )}
    </Box>
  )
}
export default Deadline
